import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const courseSingleOverviewSummaryTableHeadings = [
	{ data: 'usersEnrolled', title: ls('Users enrolled') },
	{
		data: 'avgQuizScore',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsAvgQuizScore, reportingApiSetup.learnDashLabels.quiz)
	}
];

const courseSingleOverviewSummaryTableDataObject = function(courseID) {
	var courseData = dataObject.courseList[courseID];
	var userList = dataObject.userList;
	let userAccess;
	let usersEnrolled = 0;

	// Check enrollment
	if ('open' === courseData.course_price_type) {
		usersEnrolled = Object.keys(userList.allUserIds).length;
	} else {
		if ("1" === reportingApiSetup.optimized_build) {
			if (typeof userList.course_user_access_list[courseID] !== 'undefined') {
				userAccess = dataObject.userList.course_user_access_list[courseID];
				jQuery.each(userAccess, function (key, userID) {
					if (typeof userList.userOverview[userID] === 'undefined') {
						return true;
					}
					usersEnrolled++;
				});
			} else {
				usersEnrolled = 0;
			}
		}
	}

	var userQuizAverage = userList.courseQuizAverages[courseID];
	usersEnrolled = usersEnrolled == undefined || usersEnrolled == false || usersEnrolled == 'false' ? '0' : usersEnrolled;
	userQuizAverage = userQuizAverage == undefined || userQuizAverage == false || userQuizAverage == 'false' ? '0%' : `${userQuizAverage}%`;

	return [
		{
			usersEnrolled: usersEnrolled,
			avgQuizScore: userQuizAverage
		}
	];
};

export {
	courseSingleOverviewSummaryTableHeadings,
	courseSingleOverviewSummaryTableDataObject
};
